// MediaEmbed: smart renderer for YouTube/Vimeo/MP4 URLs.
// Used in hero (autoplay/muted/loop) and intro trailer (controls).
export function detectVideo(url) {
  if (!url) return null;
  const u = url.trim();
  // YouTube
  let m = u.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([\w-]{11})/);
  if (m) return { kind: "youtube", id: m[1] };
  // Vimeo
  m = u.match(/vimeo\.com\/(\d+)/);
  if (m) return { kind: "vimeo", id: m[1] };
  // Direct video file
  if (/\.(mp4|webm|mov)(\?|$)/i.test(u)) return { kind: "file", url: u };
  return null;
}

export default function MediaEmbed({ url, mode = "trailer", className = "" }) {
  const v = detectVideo(url);
  if (!v) return null;
  const isHero = mode === "hero";
  const common = "w-full h-full";

  if (v.kind === "file") {
    return (
      <video
        src={v.url}
        autoPlay={isHero}
        loop={isHero}
        muted={isHero}
        playsInline
        controls={!isHero}
        className={`${common} object-cover ${className}`}
      />
    );
  }
  const params = isHero
    ? "autoplay=1&mute=1&loop=1&controls=0&showinfo=0&modestbranding=1&playsinline=1"
    : "";
  const src =
    v.kind === "youtube"
      ? `https://www.youtube.com/embed/${v.id}?${params}${isHero ? `&playlist=${v.id}` : ""}`
      : `https://player.vimeo.com/video/${v.id}?${isHero ? "background=1&autoplay=1&loop=1&muted=1" : ""}`;
  return (
    <iframe
      src={src}
      title="video"
      allow="autoplay; fullscreen; picture-in-picture"
      allowFullScreen
      className={`${common} ${className}`}
      style={isHero ? { pointerEvents: "none" } : {}}
    />
  );
}
